export default __webpack_public_path__ + "static/media/contact-us-banner.9ed89e2f.webp";